<mat-horizontal-stepper (selectionChange)="stepSelect($event)">
  <mat-step
    [label]="'VARIANTS.STEPS.INGREDIENTS' | translate"
    state="dashboard_customize"
    [completed]="false"
    [stepControl]="formArrayIngredients"
  >
    <ng-template matStepContent>
      <app-variant-step-ingredients
        *ngIf="variant"
        [ingredients]="variant.ingredients"
        [formIngredients]="formArrayIngredients"
        [yieldUnits]="yieldUnits"
        [domain]="variant.domain"
        [market]="variant.market"
        [lang]="variant.lang"
        [marketingFoods]="marketingFoods"
        [isAutoControl]="formVariant?.controls?.isAutomaticallyGenerated"
        [showAutoBtn]="showAutoBtn"
      ></app-variant-step-ingredients>
    </ng-template>
  </mat-step>
  <mat-step [label]="'VARIANTS.STEPS.STEPS_INSTRUCTIONS' | translate" state="list" [completed]="false">
    <ng-template matStepContent>
      <app-variant-step-instructions
        *ngIf="variant"
        [variant]="variant"
        [steps]="variant.steps"
        [formVariant]="formVariant"
        [domain]="variant.domain"
        [market]="variant.market"
        [lang]="variant.lang"
        [applianceGroupsRefData]="applianceGroupsRefData"
        [utensilsRefData]="utensilsRefData"
        [formSteps]="formArraySteps"
      ></app-variant-step-instructions>
    </ng-template>
  </mat-step>

  <mat-step [label]="'VARIANTS.STEPS.INFORMATIONS' | translate" state="informations" [completed]="false">
    <ng-template matStepContent>
      <app-variant-step-informations
        *ngIf="variant"
        [variant]="variant"
        [formVariant]="formVariant"
        [domain]="variant.domain"
        [market]="variant.market"
        [lang]="variant.lang"
        [yieldUnits]="yieldUnits"
        [marketingFoods]="marketingFoods"
      ></app-variant-step-informations>
    </ng-template>
  </mat-step>

  <mat-step [label]="'VARIANTS.STEPS.COMMENTS' | translate" state="comments" [completed]="false">
    <ng-template matStepContent>
      <app-variant-step-comments *ngIf="variant" [variant]="variant"></app-variant-step-comments>
    </ng-template>
  </mat-step>

  <!-- Dynamically overrides the "edit" pen icon that material sets on the active step -->
  <ng-template matStepperIcon="edit">
    <mat-icon>{{ selectedStepIcon }}</mat-icon>
  </ng-template>
</mat-horizontal-stepper>
